import React, {
  createContext,
  useState,
  useReducer,
  useEffect,
  useRef,
} from 'react';
import { useFetch } from '../hooks/useFetch';

const FilterContext = createContext();

const initialState = {
  lamparas: [],
  ambientes: [],
  aplicaciones: [],
  delimiters: { page: 0, limit: 4 },
  productos: [],
  productosDisplay: [],
  sort: {},
  loading: true,
  filtros: [],
};
function filterReducer(state, action) {
  switch (action.type) {
    case 'set_productos': {
      return { ...state, productos: action.payload.productos };
    }
    case 'set_lamparas': {
      return { ...state, lamparas: action.payload.lamparas };
    }
    case 'set_ambientes': {
      return { ...state, ambientes: action.payload.ambientes };
    }
    case 'set_aplicaciones': {
      return { ...state, aplicaciones: action.payload.aplicaciones };
    }
    case 'set_aplicaciones_filter': {
      return {
        ...state,
        filtros: {
          ...state.filtros,
          aplicaciones: action.payload.aplicaciones,
        },
      };
    }
    case 'set_ambientes_filter': {
      return {
        ...state,
        filtros: {
          ...state.filtros,
          ambientes: action.payload.ambientes,
        },
      };
    }
    case 'set_lamparas_filter': {
      return {
        ...state,
        filtros: {
          ...state.filtros,
          lamparas: action.payload.lamparas,
        },
      };
    }
    case 'set_productos_display': {
      return { ...state, productosDisplay: action.payload.productos };
    }
  }
}

const FilterContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(filterReducer, initialState);
  const aplicaciones = useFetch(
    'https://www.fabrilum.com.ar/backend/getAplicaciones.php',
  );
  const ambientes = useFetch(
    'https://www.fabrilum.com.ar/backend/getAmbientes.php',
  );
  const lamparas = useFetch(
    'https://www.fabrilum.com.ar/backend/getLamparas.php',
  );
  const productos = useFetch(
    'https://fabrilum.com.ar/backend/getProductos.php',
  );

  useEffect(() => {
    if (productos.data) {
      dispatch({
        type: 'set_productos',
        payload: { productos: productos.data[0] },
      });
      dispatch({
        type: 'set_productos_display',
        payload: { productos: productos.data[0] },
      });
    }
  }, [productos.status]);
  useEffect(() => {
    if (aplicaciones.data) {
      dispatch({
        type: 'set_aplicaciones',
        payload: { aplicaciones: aplicaciones.data[0] },
      });
    }
  }, [aplicaciones.status]);

  useEffect(() => {
    if (ambientes.data) {
      dispatch({
        type: 'set_ambientes',
        payload: { ambientes: ambientes.data[0] },
      });
    }
  }, [ambientes.status]);

  useEffect(() => {
    if (lamparas.data) {
      dispatch({
        type: 'set_lamparas',
        payload: { lamparas: lamparas.data[0] },
      });
    }
  }, [lamparas.status]);

  useEffect(() => {
    let filtrados = [...state.productos];
    if (state.filtros.aplicaciones?.length > 0) {
      filtrados = filtrados.filter((p) =>
        state.filtros.aplicaciones?.includes(p.aplicacion),
      );
    }
    if (state.filtros.ambientes?.length > 0) {
      filtrados = filtrados.filter((p) =>
        state.filtros.ambientes?.includes(p.ambiente),
      );
    }
    if (state.filtros.lamparas?.length > 0) {
      filtrados = filtrados.filter((p) =>
        state.filtros.lamparas?.includes(p.lampara),
      );
    }
    dispatch({
      type: 'set_productos_display',
      payload: { productos: filtrados },
    });
  }, [JSON.stringify(state.filtros)]);

  return (
    <FilterContext.Provider value={{ state, dispatch }}>
      {children}
    </FilterContext.Provider>
  );
};

export { FilterContext, FilterContextProvider };
